/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const AlarmClock16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 3a6 6 0 110 12A6 6 0 018 3zm0 1a5 5 0 100 10A5 5 0 008 4zm0 1.5a.5.5 0 01.5.5v3.5h1.732a.5.5 0 110 1h-2a.501.501 0 01-.116-.014A.5.5 0 017.5 10V6a.5.5 0 01.5-.5zm2.018-4.433l3.464 2a.5.5 0 11-.5.866l-3.464-2a.5.5 0 11.5-.866zm-3.353.183a.5.5 0 01-.183.683l-3.464 2a.5.5 0 11-.5-.866l3.464-2a.5.5 0 01.683.183z"
        />
    </AccessibleSVG>
);

export default AlarmClock16;
